import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiUserInputTitle } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiUserInputTitleDialogData {
  user_input_titles?: ApiUserInputTitle[];
}

@Component({
  selector: 'app-multi-user-input-title-dialog',
  templateUrl: './multi-user-input-title-dialog.component.html',
  styleUrls: ['./multi-user-input-title-dialog.component.css'],
  standalone: false,
})
export class MultiUserInputTitleDialogComponent implements OnInit {

  //名称×言語数
  userInputTitles: ApiUserInputTitle[] = [];
  userInputTitlesFormGroup!: FormGroup;
  userInputTitlesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiUserInputTitleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiUserInputTitleDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.userInputTitles = this.data.user_input_titles!;
    if (!this.userInputTitles) {
      this.userInputTitles = [];
    }
    this.createForm();
    this.userInputTitlesArrayControl = this.userInputTitlesFormGroup.get('userInputTitles') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.userInputTitlesFormGroup.disable();
    }
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.userInputTitles.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let user_input_title = '';
      let trans_user_input_title = '';
      for (const value of this.userInputTitles) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          user_input_title = value.user_input_title;
          trans_user_input_title = value.trans_user_input_title;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          userInputTitle: [user_input_title, []],
          transUserInputTitle: [trans_user_input_title],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          userInputTitle: [user_input_title],
          transUserInputTitle: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.userInputTitlesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        userInputTitles: arrayControl
      }
    );
  }

  //更新ボタン
  addUserInputTitles(): void {
    if (this.userInputTitlesFormGroup.valid) {
      let userInputTitles = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.userInputTitlesArrayControl.controls[index];
        userInputTitles.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            user_input_title: ctrl.get('userInputTitle')!.value,
            trans_user_input_title: ctrl.get('transUserInputTitle')!.value,
          }
        )
      }
      this.userInputTitles = userInputTitles;
      this.dialogRef.close(this.userInputTitles);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.userInputTitlesFormGroup.get('autoAllTrans')!.value;
    for (const userInputTitle of this.userInputTitlesArrayControl.controls) {
      userInputTitle.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.userInputTitlesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const userInputTitle of this.userInputTitlesArrayControl.controls) {
      if (!userInputTitle.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.userInputTitlesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
